<template lang="html">

  <section class="login">
    <div class="wrapper d-flex align-items-center auth login-full-bg">
      <div class="row w-100">
        <div class="col-lg-6 mx-auto">
          <div class="auth-form-light text-left p-5">
            <h2>Login</h2>
            <h4 class="font-weight-light">Maserati Car Configurator Admin</h4>
            <form class="pt-5">
              <form>     
                <b-alert variant="danger" dismissible :show="loginError">
                  <i class="mdi mdi-alert-octagon"></i> Login failed
                </b-alert>
                <div class="form-group">
                  <label for="exampleInputEmail1">Username</label>
                  <input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Username" v-model="username">
                  <i class="mdi mdi-account"></i>
                </div>
                <div class="form-group">
                  <label for="exampleInputPassword1">Password</label>
                  <input type="password" class="form-control" id="exampleInputPassword1" placeholder="Password" v-model="password">
                  <i class="mdi mdi-eye"></i>
                </div>
                <div class="mt-5">
                  <a class="btn btn-block btn-primary btn-lg font-weight-medium" href="javascript:void(0);" @click="login">Login</a>
                </div>
                <div class="mt-3 text-center">
                  <a href="#" class="auth-link text-white">Forgot password?</a>
                </div>
              </form>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>

</template>

<script lang="js">
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  name: 'login',
  data() {
    return {
      username:"",
      password:""
    }
  },
  methods: {
    login() {
      //TODO check campi compilati
      this.setSpinnerStatus(true);
      this.axios
        .post('/ccb/public/getToken', {username:this.username, password:this.password})
          .then(response => {
            //console.log("Response: '" + response.data + "' with Statuscode " + response.status);
            if(response.status == 200) {
              //console.log("Login successful");
              // place the loginSuccess state into our vuex store
              this.login_success(response.data);
              this.$nextTick(() => { 
                //this.loadFullModelsByCountry(response.data.user.countries[0].id);
                this.setFullModelList(response.data.user.ccadmFullModelList)
                this.loadLanguages();
                this.loadMenuList();
                this.$router.push("/");
                this.setSpinnerStatus(true);
              })
            }
          })
          .catch(error => {
            this.setSpinnerStatus(false);
            this.$bvModal.msgBoxOk(error.message, {
              okVariant: 'danger',
              hideHeaderClose: false,
              centered: true
            })
            // place the loginError state into our vuex store
            this.login_error({
              username: this.username
            });
          })
    },
    loadMenuList () {
      if (this.getCurUser.ccadmEnabled) {
        this.axios
        .get('/ccb/auth/fe/menu/menulist' ,  {
          params:{modelName: this.getCurModel, language:this.getCurLanguage},
          ...this.authHeader}
            
            )
            .then((response) => {
              this.setMenuList(response.data);      
              localStorage.setItem('menuList', JSON.stringify(response.data));
              var scope = this
              setTimeout(() => {
                scope.initLabelGroupList()
                document.querySelector('#sidebar .nav li span').click();
                document.querySelector('#sidebar .nav li div ul li a').click()
              }, 200);
            });
      }
      else {
        this.setMenuList({});      
        localStorage.setItem('menuList', JSON.stringify({}));
      }
    },
    initLabelGroupList(){      
      var menSrc = this.getMenuList
      if (menSrc && menSrc.submenuList) this.setLabelGroupList(menSrc.submenuList);
    },
    loadFullModelsByCountry(country){
      //console.log(country)
      this.axios
      .get('/ccb/public/api/countryModel/getModelListJsonByCountry' ,  {
        params:{country:country},
        ...this.authHeader}
          
          )
          .then((response) => {
            this.setFullModelList(response.data)
          });
    },
    loadLanguages () {
       this.axios
      .get('/ccb/auth/fe/language/langlist' ,  {
        params:null,
        ...this.authHeader}
          
          )
          .then((response) => {
            localStorage.setItem('langList', JSON.stringify(response.data));
            this.setLanguageList(response.data);          
          });
    },
    ...mapActions([
      'login_success',
      'login_error',
      'setMenuList',
      'setSpinnerStatus',
      'setFullModelList',
      'setLanguageList',
      'setLabelGroupList'
    ])
  },
  computed: {
    ...mapState([
      'loginError'
    ]),
    ...mapGetters([
      'authHeader',
      'getCurModel',
      'getMenuList',
      'getFullModelList',
      'getCurUser'
    ])
  }
}
</script>

<style scoped lang="scss">
.login {

}
</style>
